import { render, staticRenderFns } from "./client-unit-pending-prescription.vue?vue&type=template&id=bf789f0c&scoped=true&lang=pug&"
import script from "./client-unit-pending-prescription.vue?vue&type=script&lang=ts&"
export * from "./client-unit-pending-prescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf789f0c",
  null
  
)

export default component.exports